import { HttpClient, HttpErrorResponse, HttpParams, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { catchError, tap, throwError } from 'rxjs';
import { ErrorVTO } from '../../pages/admin-dashboard/products/product.model';
import { AuthService } from '../auth-service';
import {
  CancellationReasonsResponse,
  UndeliveredReasonsResponse,
} from '../../pages/admin-dashboard/orders-management/view-order/view-order.model';

@Injectable({ providedIn: 'root' })
export class ReasonsService {
  private authService = inject(AuthService);
  private http = inject(HttpClient);
  private API = environment.pharmacyMgtApiUrl;

  getRejectionReasons() {
    const token = this.authService.getAccessToken();
    let headers = new HttpHeaders();
    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }

    return this.http.get(`${this.API}/orders/rejection/reasons`, { headers }).pipe(
      tap(() => console.log('MFG companies retrieved successfully')),
      catchError(this.handleError),
    );
  }

  getUndeliveredReasons() {
    const token = this.authService.getAccessToken();

    let headers = new HttpHeaders();

    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }

    return this.http.get<UndeliveredReasonsResponse>(`${this.API}/lookup/orders/undelivered/reasons`, { headers }).pipe(
      tap(() => console.log('Undelivered reasons retrieved successfully')),
      catchError(this.handleError),
    );
  }
  getCancellationReasons() {
    const token = this.authService.getAccessToken();

    let headers = new HttpHeaders();

    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }

    return this.http
      .get<CancellationReasonsResponse>(`${this.API}/lookup/orders/cancellation/reasons`, { headers })
      .pipe(
        tap(() => console.log('Cancellation reasons retrieved successfully')),
        catchError(this.handleError),
      );
  }

  private handleError(error: HttpErrorResponse) {
    const apiError: ErrorVTO = error.error;
    console.error('An API error occurred:', apiError);
    return throwError(() => apiError);
  }
}
